// Zustand auth store
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
// =============================================================================
// Auth Store
// =============================================================================
export const useAuthStore = create()(persist((set) => ({
    // Initial state
    user: null,
    token: null,
    broker: null,
    isAuthenticated: false,
    isLoading: true,
    currentSiteCode: null,
    // Actions
    setUser: (user) => set({
        user,
        isAuthenticated: !!user,
    }),
    setToken: (token) => set((state) => ({ token, broker: state.token === token ? state.broker : null })),
    setSession: (token, broker) => set({ token, broker: broker ?? null }),
    login: (user, token) => set((state) => ({
        broker: state.token === token ? state.broker : null,
        user,
        token,
        isAuthenticated: true,
        isLoading: false,
    })),
    logout: () => set({
        user: null,
        token: null,
        broker: null,
        isAuthenticated: false,
        isLoading: false,
        currentSiteCode: null,
    }),
    setLoading: (isLoading) => set({
        isLoading,
    }),
    setSite: (currentSiteCode) => set({
        currentSiteCode,
    }),
}), {
    name: 'bms-auth',
    storage: createJSONStorage(() => sessionStorage),
    // Only persist minimal data, not loading states
    partialize: (state) => ({
        user: state.user,
        token: state.token,
        broker: state.broker,
        isAuthenticated: state.isAuthenticated,
        currentSiteCode: state.currentSiteCode,
    }),
}));
export const useUiStore = create()(persist((set) => ({
    // Sidebar state
    sidebarCollapsed: false,
    toggleSidebar: () => set((state) => ({
        sidebarCollapsed: !state.sidebarCollapsed,
    })),
    setSidebarCollapsed: (collapsed) => set({
        sidebarCollapsed: collapsed,
    }),
    // Theme (legacy — kept for backward compat with persisted localStorage)
    theme: 'light',
    setTheme: (theme) => set({
        theme,
    }),
    // Admin UI theme (default: light)
    adminTheme: 'light',
    setAdminTheme: (theme) => set({
        adminTheme: theme,
    }),
    // User UI theme (default: follow the OS, so light mode is exercised on
    // light machines rather than only when someone opts into it)
    userTheme: 'system',
    setUserTheme: (theme) => set({
        userTheme: theme,
    }),
    // Admin UI density (default: comfortable)
    adminDensity: 'comfortable',
    setAdminDensity: (density) => set({
        adminDensity: density,
    }),
    // Locale
    locale: 'en',
    setLocale: (locale) => set({
        locale,
    }),
    // Current context
    currentRoomCode: null,
    setCurrentRoom: (roomCode) => set({
        currentRoomCode: roomCode,
    }),
}), {
    name: 'bms-ui',
    storage: createJSONStorage(() => localStorage),
}));
export const useMqttConnectionStore = create((set) => ({
    state: 'disconnected',
    error: null,
    reconnectAttempts: 0,
    setState: (state) => set({ state }),
    setError: (error) => set({ error, state: error ? 'error' : 'disconnected' }),
    incrementReconnectAttempts: () => set((state) => ({
        reconnectAttempts: state.reconnectAttempts + 1,
    })),
    resetReconnectAttempts: () => set({ reconnectAttempts: 0 }),
}));
//# sourceMappingURL=authStore.js.map